export const AUDIENCE_CONTRACT = {
  constituent: { persona: 'political', delta: [0, 1, 0, -1] },
  department: { persona: 'political', delta: [1, -1, 1, -1] },
  media: { persona: 'political', delta: [1, -1, 0, -1] },
  customer: { persona: 'business', delta: [0, 1, 0, 0] },
  supplier: { persona: 'business', delta: [1, -1, 1, 0] },
  partner: { persona: 'business', delta: [0, 1, 0, 1] },
  client: { persona: 'legal', delta: [1, 1, 1, -1] },
  counsel: { persona: 'legal', delta: [1, -1, 1, 0] },
  court: { persona: 'legal', delta: [1, -1, 1, -1] },
  supporter: { persona: 'nonprofit', delta: [0, 1, 0, -1] },
  funder: { persona: 'nonprofit', delta: [1, -1, 1, -1] },
  internal: { persona: 'shared', delta: [-2, 0, -2, 1] },
} as const;

export const PERSONA_AUDIENCE_CONTRACT = {
  political: ['constituent', 'department', 'internal', 'media'],
  business: ['customer', 'supplier', 'internal', 'partner'],
  legal: ['client', 'counsel', 'internal', 'court'],
  nonprofit: ['supporter', 'funder', 'internal', 'media'],
} as const;

export const PERSONA_DEFAULT_AUDIENCE = {
  political: 'constituent',
  business: 'customer',
  legal: 'client',
  nonprofit: 'supporter',
} as const;

export const PERSONA_DERIVATION_CONTRACT = [
  {
    persona: 'legal',
    keywords: [
      'law',
      'legal',
      'solicitor',
      'solicitors',
      'barrister',
      'barristers',
      'attorney',
      'attorneys',
      'chambers',
      'counsel',
      'lawyer',
      'lawyers',
      'paralegal',
      'conveyancing',
    ],
    phrases: [],
  },
  {
    persona: 'nonprofit',
    keywords: ['charity', 'charities', 'charitable', 'nonprofit', 'ngo', 'foundation', 'community'],
    phrases: ['non-profit', 'not-for-profit', 'not for profit'],
  },
  {
    persona: 'political',
    keywords: [
      'electorate',
      'electoral',
      'mp',
      'mlc',
      'mla',
      'minister',
      'ministerial',
      'parliament',
      'parliamentary',
      'council',
      'councils',
      'councillor',
      'mayor',
      'mayoral',
      'senator',
      'senators',
      'government',
      'govt',
    ],
    phrases: [],
  },
  {
    persona: 'business',
    keywords: [
      'business',
      'company',
      'companies',
      'firm',
      'firms',
      'consulting',
      'consultancy',
      'consultant',
      'agency',
      'agencies',
      'retail',
      'commerce',
      'startup',
      'startups',
      'enterprise',
      'enterprises',
      'corp',
      'corporation',
      'llc',
      'ltd',
      'pty',
      'studio',
    ],
    phrases: [],
  },
] as const;
